<template>
  <h1 class="text-center">Features</h1>
</template>

<script>
export default {
  name: "Features"
}
</script>

<style scoped>

</style>